import type { ComponentProps, PropsWithChildren } from 'react';

import { Html } from '@change-corgi/design-system/html';
import { Box } from '@change-corgi/design-system/layout';
import { Text } from '@change-corgi/design-system/typography';

import { ContributionCount } from './components/ContributionCount';
import { useImpactBox } from './hooks/useImpactBox';

export function ImpactBox({ children, ...rest }: PropsWithChildren<ComponentProps<typeof Box>>) {
	const {
		data: { heading, text },
	} = useImpactBox();

	return (
		<Box data-qa="impact-box" {...rest}>
			<Text as="div" color="primary-changeRed" fontWeight="bold" sx={{ textTransform: 'uppercase' }} mb={8}>
				{heading}
			</Text>
			<ContributionCount />
			{text && <Html html={text} as="div" />}
			{children}
		</Box>
	);
}
